import { render } from "./vuestic-logo.vue?vue&type=template&id=4e683e5c"
import script from "./vuestic-logo.vue?vue&type=script&lang=js"
export * from "./vuestic-logo.vue?vue&type=script&lang=js"
script.render = render

export default script